



























































import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import Vue from 'vue'

@Component
export default class MenuItem extends Vue {
  @Prop()
  color: string;

  @Prop()
  title: string;

  @Prop()
  icon: string;

  @Prop()
  dropdown: boolean;

  @Prop()
  last: boolean;

  @Prop()
  value: boolean;

  @Prop()
  decorativeDropdown: boolean;

  @Prop({ default: false })
  selectable: boolean;

  @Prop({ default: false })
  selected: boolean;

  @Prop()
  warning: boolean;

  @Emit('input')
  onInput(value: boolean) {}

  pValue: boolean = false;

  get chevronValue() {
    return this.isDecorativeDropdown 
      ? this.decorativeDropdown
      : this.pValue;
  }

  get isDecorativeDropdown() {
    return typeof this.decorativeDropdown === 'boolean';
  }

  get computedValue() {
    return this.pValue;
  }

  set computedValue(value: boolean) {
    this.pValue = value;
    this.onInput(value);
  }

  @Watch('value', { immediate: true })
  onValueChanged(value: boolean, oldValue: boolean) {
    if(value !== this.pValue) {
      this.pValue = value;
    }
  }

  @Emit('click')
  onClick() {}

  handleContentClick() {
    if(this.dropdown) {
      this.computedValue = !this.computedValue;
    }
  }
}
